import './DeliveryAlert.scss';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Row, Col, CardBody, CardHeader, Button } from 'reactstrap';

const DeliveryAlert = (props) => {
  const { deliveryDt, status } = props || {};
  let orderSts = status;
  orderSts = orderSts.toLowerCase();
  if (
    deliveryDt &&
    orderSts !== 'delivered' &&
    orderSts !== 'canceled' &&
    orderSts !== 'pending payment'
  ) {
    // Convert strings to Date objects
    const delDate = new Date(deliveryDt);
    const endDateDate = new Date();
    // Calculate the difference in milliseconds
    const dateDifferenceInMillis = endDateDate - delDate;
    // Convert milliseconds to days (1 day = 24 hours = 86400000 milliseconds)
    const dateDifferenceInDays = Math.floor(
      dateDifferenceInMillis / (24 * 60 * 60 * 1000)
    );
    if (dateDifferenceInDays > 0) {
      return (
        <div
          className="d-flex align-items-center justify-content-start gap-1 bg-soft-danger border border-danger px-2 rounded text-danger"
          style={{ width: 100 }}
        >
          <i className="mdi mdi-truck-outline fs-16 lh-15"></i>
          <p className="m-0 fs-10">{dateDifferenceInDays} Day Delay</p>
        </div>
      );
    }
  }
  return <></>;
};
export default DeliveryAlert;
